import { useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/client";
import "../styles/auth.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email) {
      setError("Please enter your email address.");
      return;
    }
    setLoading(true);
    try {
      await apiClient.post("/api/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      // Always show success even if email not found — security best practice
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#f2efe8" }}>
      <Navbar />
      <div className="auth-page">
        <div className="auth-card">
        <Link to="/" className="logo">
          <span className="auth-logo-text">
            ScriptedCAD
          </span>
        </Link>

        {sent ? (
          <div className="auth-success-state">
            <div className="auth-success-icon">✓</div>
            <h1 className="auth-heading">Check your email</h1>
            <p className="auth-sub">
              If an account exists for <strong>{email}</strong>, we've sent a
              password reset link. Check your inbox and spam folder.
            </p>
            <p className="auth-sub" style={{ marginTop: "1rem" }}>
              The link expires in <strong>1 hour</strong>.
            </p>
            <div className="auth-switch" style={{ marginTop: "2rem" }}>
              <Link to="/login">← Back to sign in</Link>
            </div>
          </div>
        ) : (
          <>
            <h1 className="auth-heading">Reset your password</h1>
            <p className="auth-sub">
              Enter your email and we'll send you a reset link from{" "}
              <strong>noreply@scriptedcad.com</strong>.
            </p>

            {error && <div className="auth-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="auth-field">
                <label>Email address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoFocus
                />
              </div>
              <button type="submit" className="auth-btn" disabled={loading}>
                {loading && <span className="auth-spinner" />}
                {loading ? "Sending..." : "Send reset link"}
              </button>
            </form>

            <div className="auth-switch" style={{ marginTop: "1.5rem" }}>
              <Link to="/login">← Back to sign in</Link>
            </div>
          </>
        )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;
